import { Alert, Box, Button, CircularProgress, MenuItem, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { fetchCurrentCustomerDetails, updateMfaSettings } from "../services/userService";
import { validateEmail } from "../utils/emailUtil";

/** Povinné doplnění MFA po přihlášení stávajícího uživatele. */
export default function MfaSettingsPage() {
  const [email, setEmail] = useState("");
  const [telefon, setTelefon] = useState("");
  const [mfaTyp, setMfaTyp] = useState("EMAIL");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      const result = await fetchCurrentCustomerDetails();
      if (!result.success) {
        setError(result.message || "Nastavení MFA se nepodařilo načíst.");
      } else {
        setEmail(result.data?.email || "");
        setTelefon(result.data?.telefon || "");
        setMfaTyp(result.data?.mfaTyp || "EMAIL");
      }
      setLoading(false);
    };
    load();
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (mfaTyp === "EMAIL" && !validateEmail(email)) {
      setError("Pro e-mailové MFA vyplňte platný e-mail.");
      return;
    }
    if (mfaTyp === "SMS" && !telefon.trim()) {
      setError("Pro MFA přes SMS vyplňte telefon.");
      return;
    }
    const result = await updateMfaSettings(email.trim(), telefon.trim(), mfaTyp);
    if (!result.success) {
      setError(result.message || "Nastavení MFA se nepodařilo uložit.");
      return;
    }
    // ProtectedRoute drží stav MFA z okamžiku přihlášení. Po uložení jej
    // načteme znovu ze serveru, aby uživatel nebyl vrácen na tento formulář.
    window.location.replace("/zvk/aktuality");
  };

  if (loading) return <Box sx={{ textAlign: "center", p: 3 }}><CircularProgress /></Box>;

  return (
    <Box sx={{ maxWidth: 440, mx: "auto", my: 2 }}>
      <Typography variant="h5" sx={{ mt: 3, mb: 2 }}>Nastavte vícefázové přihlášení</Typography>
      <Alert severity="info" sx={{ mb: 2 }}>
        Nejprve vyberte způsob multifaktorového ověření (MFA) a poté vyplňte kontakt, na který mají chodit ověřovací kódy.
      </Alert>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Box component="form" onSubmit={handleSubmit}>
        <TextField select label="Preferovaný typ multifaktorového ověření (MFA)" value={mfaTyp}
          onChange={(event) => setMfaTyp(event.target.value)} fullWidth sx={{ mb: 2 }}>
          <MenuItem value="EMAIL">E-mail</MenuItem>
          <MenuItem value="SMS">SMS</MenuItem>
        </TextField>
        {mfaTyp === "EMAIL" ? (
          <TextField label="E-mail pro MFA" type="email" value={email}
            onChange={(event) => setEmail(event.target.value)} fullWidth required sx={{ mb: 2 }} />
        ) : (
          <TextField label="Telefon pro MFA" value={telefon}
            onChange={(event) => setTelefon(event.target.value)} fullWidth required sx={{ mb: 2 }} />
        )}
        <Button type="submit" variant="contained" fullWidth>Uložit a pokračovat</Button>
      </Box>
    </Box>
  );
}
